import React from "react";

import FindStoreIcon from "components/Icons/find_store_stylized.svg";
import ShoppingBagIcon from "components/Icons/shopping_bag_stylized.svg";
import ShoppingCartIcon from "components/Icons/shopping_cart_stylized.svg";

const HowItWorks = (): JSX.Element => (
  <div className="container py-xl">
    <div className="row text-center">
      <h2 className="heading--xl py-lg">How it works</h2>
    </div>
    <div className="row">
      <div className="lg:col-1/3 p-xl">
        <div className="flex flex-col items-center m-auto">
          <FindStoreIcon width="56" height="56" />
          <div className="font-bold text-sm pt-md pb-xs">Pick a store</div>
          <div className="text-sm text-center">
            Filter your options by distance, reviews, and more.
          </div>
        </div>
      </div>
      <div className="lg:col-1/3 p-xl">
        <div className="flex flex-col items-center m-auto">
          <ShoppingBagIcon width="56" height="56" />
          <div className="font-bold text-sm pt-md pb-xs">Fill your cart</div>
          <div className="text-sm text-center">
            Shop your store's menu, add items to your Leafly cart.
          </div>
        </div>
      </div>
      <div className="lg:col-1/3 p-xl">
        <div className="flex flex-col items-center m-auto">
          <ShoppingCartIcon width="68" height="56" />
          <div className="font-bold text-sm pt-md pb-xs">Send the order</div>
          <div className="text-sm text-center">
            You'll get a text confirming they got it, and pay when it's picked
            up or delivered.
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HowItWorks;
